import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '../../stores/authStore'

const KEY = 'birthday-nudge-dismissed'

/**
 * Non-blocking top-of-app banner prompting the logged-in user to add their
 * birthday when it isn't set. Dismisses to localStorage so it doesn't
 * reappear. Self-hides when not applicable (no user, birthday set, dismissed).
 */
export function BirthdayNudge() {
  const user = useAuthStore(s => s.user)
  const navigate = useNavigate()
  const [dismissed, setDismissed] = useState(() => localStorage.getItem(KEY) === '1')

  if (!user || user.birthday || dismissed) return null

  return (
    <div className="flex items-center justify-between gap-3 bg-primary/10 text-foreground text-sm px-4 py-2">
      <span>🎂 Add your birthday so we can celebrate with you.</span>
      <span className="flex gap-2">
        <button
          className="font-semibold text-primary"
          onClick={() => navigate('/profile?tab=profile')}
        >
          Add now
        </button>
        <button
          className="text-muted-foreground"
          onClick={() => { localStorage.setItem(KEY, '1'); setDismissed(true) }}
        >
          Dismiss
        </button>
      </span>
    </div>
  )
}

export default BirthdayNudge
